module.exports = __webpack_public_path__ + "assets/4-vice-president-of-sales.1a8fee15.png";